import { Center, Group, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { ReviewApproval } from 'types/lcms/courses';
import AdminSMEItem from './AdminSMEItem';

interface PICMaterialSectionProps {
  data: ReviewApproval | undefined;
  courseId: string;
}

const PICMaterialSection = ({ data, courseId }: PICMaterialSectionProps) => {
  const { picApproval } = data || { picApproval: [] };

  return (
    <Card>
      <Stack gap={16}>
        <Group justify='space-between'>
          <Group gap={8}>
            <HiOutlineDocumentText />
            <Text c={'dark'} fw={700}>
              PIC Material
            </Text>
          </Group>
        </Group>

        {picApproval.length === 0 && (
          <Center>
            <Text c={'dark'} fz={'sm'} ta={'center'}>
              PIC material not available yet.
            </Text>
          </Center>
        )}

        {picApproval.length > 0 && (
          <Stack gap={16}>
            {picApproval.map((item, index) => (
              <AdminSMEItem
                key={index}
                item={{
                  ...(item as any),
                  smeId: item.binusianID
                }}
                courseId={courseId}
                noBadge={true}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default PICMaterialSection;
